import "./medicalStaff.scss";
import React, { useEffect, useState } from "react";
import { Box, Card, Container, CardContent } from "@mui/material";
import { PageLayout } from "../../../components/page/page-layout";
import { MedicalStaffListToolbar } from "../../../components/doctor/medical-staff/medical-staff-list-toolbar";
import { MedicalStaffListResults } from "../../../components/doctor/medical-staff/medical-staff-list-results";
import { MedicalStaffSearch } from "../../../components/doctor/medical-staff/medical-staff-search";
import { consultaMedicos } from "../../../services/MedicalStaffService";

const MedicalStaff = () => {
  const [listDoctors, setListDoctors] = useState([]);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const criteria = {
          // aprobado: false,
          page: 1,
          estado: 0
        };

        const doctors = await consultaMedicos(criteria);
        setListDoctors(doctors);
      } catch (error) {
        console.error("Error al cargar los datos del servicio", error);
      }
    };

    fetchData();
  }, []);

  const handleSearch = (doctors) => {
    setListDoctors(doctors);
  };

  return (
    <PageLayout>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
          <Card
            sx={{
              border: "0.5px solid #dddddd",
              padding: "1px",
              boxShadow: "1px 1px #d5d5d5",
            }}
          >
            <CardContent>
              <MedicalStaffListToolbar />
              <Box sx={{ mt: 7 }}>
                <MedicalStaffSearch onSearch={handleSearch} />
                <MedicalStaffListResults doctors={listDoctors} /* loading={loadingData} */ />
              </Box>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </PageLayout>
  );
};

export default MedicalStaff;
